export class FileInfo {
  constructor(public fileName: string, public size: number, public type: string, public data: Promise<any>) {}
}
